import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { LANGUAGES, RTL_LANGS, t as translate } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "ph_lang";

function detectInitialLang() {
  const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
  if (typeof navigator !== "undefined") {
    const nav = (navigator.language || "fr").slice(0, 2).toLowerCase();
    if (LANGUAGES.some((l) => l.code === nav)) return nav;
  }
  return "fr";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(detectInitialLang);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", RTL_LANGS.has(lang) ? "rtl" : "ltr");
  }, [lang]);

  const t = useCallback((key) => translate(key, lang), [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t, languages: LANGUAGES }),
    [lang, t],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
}
